import { Button} from "bootstrap";
import { Row, Col, Container } from "react-bootstrap";
import * as React from "react";

function Error404() {
  return (
    <div className="404">
        <Container>
            <h3>Page not found!</h3>
        </Container>
        
    </div>
  );
}

export default Error404;
